import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCreditCardAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"credit-card-add, card, payment"} maskId="square-filled-radius-0-stroke-1-IconCreditCardAdd"><path d="M2 4H22V9.5H2V4Z" fill="currentColor"/><path d="M2 10.5V20H18V19H15V16H18V13H21V16H22V10.5H2Z" fill="currentColor"/><path d="M20 17V14H19V17H16V18H19V21H20V18H23V17H20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCreditCardAdd;
